/** @jsxImportSource minimal-view */

import { element, view, web } from 'minimal-view'
import { skin } from './skin'
import { hmr } from './hmr'

export type Icon = typeof Icon.State

export const Icon = hmr(web(view('icon',
  class props {
    name!: string
  },
  class local {
    host = element
    icons?: Map<string, string>
  },
  function actions({ $, fn, fns }) {
    return fns(new class actions {
    })
  },
  function effects({ $, fx, deps, refs }) {
    fx(() => skin.fx(({ colors }) => {
      $.css = /*css*/`
      & {
        display: inline-flex;
        width: 100%;
        height: 100%;
      }

      svg {
        fill: currentcolor;
        stroke: currentcolor;
      }

      .mdi-light\\:repeat {
        stroke-width: 25px;
        stroke-linejoin: miter;
      }
      `
    }))

    fx(async () => {
      const res = await fetch('/example/iconfont.svg')
      const svg = await res.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(svg, 'application/xml')
      const glyphs = doc.querySelectorAll('glyph')
      $.icons = new Map(
        [...glyphs].map((g) => [
          g.getAttribute('glyph-name')!,
          g.getAttribute('d')!,
        ]))
    })

    fx(({ name, icons }) => {
      $.view = <svg width="100%" height="100%" viewBox="0 0 1000 1000" class={name}>
        <path d={icons.get(name)!} />
      </svg>
    })
  }
)))
